import { createRouter, createWebHistory } from 'vue-router'
import Selector from '@/views/Selector.vue'

const routes = [
  {
    path: '/selector/:page?',
    name: 'selector',
    component: Selector,
    props: true
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
